module.exports = __webpack_public_path__ + "assets/img/pinpai-cp1.40a34159.png";